import { render, staticRenderFns } from "./ChatbotPromptView.vue?vue&type=template&id=483b81f9&scoped=true"
import script from "./ChatbotPromptView.vue?vue&type=script&lang=js"
export * from "./ChatbotPromptView.vue?vue&type=script&lang=js"
import style0 from "./ChatbotPromptView.vue?vue&type=style&index=0&id=483b81f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b81f9",
  null
  
)

export default component.exports